export const DEFAULT_OPENING_TIME = '06:00';
export const DEFAULT_CLOSING_TIME = '22:00';

export interface OpeningHours {
    openingTime: string;
    closingTime: string;
}

/**
 * Opening hours of a storage location, falling back to the company wide
 * default whenever a location has no times configured yet.
 */
export function getOpeningHours(storageLocation: any): OpeningHours {
    return {
        openingTime:
            storageLocation?.openingTime?.trim() || DEFAULT_OPENING_TIME,
        closingTime:
            storageLocation?.closingTime?.trim() || DEFAULT_CLOSING_TIME,
    };
}

export function formatOpeningHours(storageLocation: any): string {
    const {openingTime, closingTime} = getOpeningHours(storageLocation);
    return `${openingTime} - ${closingTime}`;
}
